"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var HorizontalDividerStyles = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  margin: 30px 0px;\n  padding: 0 10px;\n  border-bottom: 1px solid;\n  border-color: ", ";\n  width: 100%;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dividerwhite ? 'rgba(112, 112, 112, 0.6)' : 'var(--bf-op15-core-gray)';
});
var HorizontalDivider = function HorizontalDivider(_ref) {
  var props = Object.assign({}, _ref);
  return _react.default.createElement(HorizontalDividerStyles, props);
};
var _default = HorizontalDivider;
exports.default = _default;